// src/LoginPage.js
import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { Button, Box, Typography } from "@mui/material";

const LoginPage = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest)
      .then((response) => {
        console.log("Login success", response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f5f5f5"
      }}
    >
      <Typography variant="h4" sx={{ mb: 3 }}>Welcome to Data Bridge</Typography>
      <Button variant="contained" onClick={handleLogin}>
        Login with Azure AD
      </Button>
    </Box>
  );
};

export default LoginPage;
